import { fetch } from 'whatwg-fetch';
import cognitoAuth from '../../utils/cognitoAuth.mjs';
import { toNationalNumber } from '../../utils/phoneNumberFormatter';
import salesforceConfig from '../../utils/salesforceConfig.mjs';
import requiresEmployeeToken from '../../utils/tokenAuth.mjs';

const sendToSalesforce = async (uuid, employee, data, questionsOrder) => {
  const token = await cognitoAuth();

  if(!data)
    throw new Error("no data to send");
  
  const employeeRefreshToken = await requiresEmployeeToken(uuid, employee, false);
  const userInfo = {
    ...data,
    ...(data.companyPhone && { companyPhone: toNationalNumber(data.companyPhone)}),
    contactPhone: toNationalNumber(data.contactPhone),
  };

  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
  const body = JSON.stringify({
    command: 'SalesforceEngageHub',
    ...(employeeRefreshToken && { token: employeeRefreshToken }),
    uuid,
    userInfo,
    notes: [],
    questionsOrder,
  });


  return fetch(salesforceConfig().salesforceUrl, {method: 'POST', headers, body})
    .then(response => {
      if(response.ok) { 
        return response.json(); 
      } else {
        throw new Error(response.statusText); 
      } 
    })
    .catch( err => {
      throw new Error(err.message); 
    });
}

export default sendToSalesforce;



